import React, { memo } from 'react';

import { defaultSize, sizePropsTypes } from './icons.constants';

const CreateNoticeIcon = ({ size = defaultSize, ...props }) => (
  <svg
    fill="none"
    height={size}
    viewBox="0 0 24 24"
    width={size}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M5.66303 8.13333C5.66303 4.70968 8.53721 2 12 2C12.5523 2 13 2.44772 13 3C13 3.55228 12.5523 4 12 4C9.56773 4 7.66303 5.88687 7.66303 8.13333V9.69212C7.66303 11.1155 7.35846 12.5226 6.76954 13.8255L6.03353 15.4537C5.94007 15.6604 6.07288 16 6.45714 16H17.5429C17.9271 16 18.0599 15.6604 17.9665 15.4537L17.2305 13.8255C17.0005 13.3167 16.8138 12.7919 16.6718 12.2564C16.5301 11.7226 16.848 11.1751 17.3819 11.0334C17.9157 10.8918 18.4632 11.2097 18.6049 11.7436C18.7186 12.1724 18.8683 12.5931 19.0529 13.0017L19.7889 14.6299C20.5314 16.2724 19.2551 18 17.5429 18H6.45714C4.74493 18 3.46863 16.2724 4.21108 14.6299L4.94708 13.0017C5.41976 11.956 5.66303 10.8296 5.66303 9.69212V8.13333ZM16.5 2C17.0523 2 17.5 2.44772 17.5 3V4.5H19C19.5523 4.5 20 4.94772 20 5.5C20 6.05228 19.5523 6.5 19 6.5H17.5V8C17.5 8.55228 17.0523 9 16.5 9C15.9477 9 15.5 8.55228 15.5 8V6.5H14C13.4477 6.5 13 6.05228 13 5.5C13 4.94772 13.4477 4.5 14 4.5H15.5V3C15.5 2.44772 15.9477 2 16.5 2ZM8.76923 19.3174C9.14623 18.9138 9.77902 18.8922 10.1826 19.2692C10.6763 19.7304 11.3116 20 12 20C12.6884 20 13.3237 19.7304 13.8174 19.2692C14.221 18.8922 14.8538 18.9138 15.2308 19.3174C15.6078 19.721 15.5862 20.3538 15.1826 20.7308C14.3438 21.5144 13.2287 22 12 22C10.7713 22 9.65625 21.5144 8.81738 20.7308C8.41379 20.3538 8.39223 19.721 8.76923 19.3174Z"
      fill="currentColor"
      fillRule="evenodd"
    />
  </svg>
);

CreateNoticeIcon.propTypes = {
  ...sizePropsTypes,
};

export default memo(CreateNoticeIcon);
